/**
 * Enumération définissant les différentes directions (du vent)
 */
enum DIRECTION {
  N = "Nord",
  E = "Est",
  S = "Sud",
  O = "Ouest",
  NE = "Nord-Est",
  SE = "Sud-Est",
  SO = "Sud-Ouest",
  NO = "Nord-Ouest",
}
export default DIRECTION;
